import { useMutation } from '@tanstack/react-query';

import { uploadFileToUrl } from '../../utils/uploadFileToUrl/uploadFileToUrl';

export const useUploadFile = () => {
  const upload = useMutation<
    void,
    Error,
    {
      url: string;
      file: File;
      onProgress?: (progress: number) => void;
      headers?: Record<string, string>;
    }
  >({
    mutationFn: async ({ file, onProgress, url, headers }) => {
      await uploadFileToUrl({
        file,
        headers,
        onProgress: (progress) => {
          if (onProgress) {
            onProgress(Math.round(progress));
          }
        },
        url,
      });
    },
  });

  return upload;
};
